/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopTimeChangeReport(props) {
  const {open, close} = props;
  const [selectValue, setSelectValue] = useState('rdo01');
  return (
    <>
      <Modal
        open={open}
        close={close}
        type="pop_time_change_report com_input
"
      >
        <h2 className="pop_tit">타임변경 / 보류 보고서</h2>
        <div
          className="content_container scroll mb_no
"
        >
          <ul className="input_list">
            <li className="com_input_wrap">
              <section className="com_board_search">
                <article className="search full">
                  <input type="search" placeholder="학생명 검색" className="input xs type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </li>
            <li className="com_input_wrap flex_row">
              <input type="text" className="input" placeholder="학생 이름" />
              <select name="" id="" className="select full">
                <option value="수업 선택">수업 선택</option>
              </select>
            </li>
            <li className="com_input_wrap flex_row">
              <input type="text" className="input" placeholder="학생 성적입력" />
              <input type="text" className="input" placeholder="학생 진도입력" />
            </li>
          </ul>
          <div className="com_radio_wrap">
            <input onChange={() => setSelectValue('rdo01')} type="radio" name="rdo" id="rdo01" className="com_chk circle" />
            <label htmlFor="rdo01">타임추가</label>
            <input onChange={() => setSelectValue('rdo02')} type="radio" name="rdo" id="rdo02" className="com_chk circle" />
            <label htmlFor="rdo02">타임축소</label>
            <input onChange={() => setSelectValue('rdo03')} type="radio" name="rdo" id="rdo03" className="com_chk circle" />
            <label htmlFor="rdo03">수업보류</label>
          </div>
          <div className="com_board_box">
            <div className="board_item">
              <div className="info">
                <span className="tit">학생명</span>
                <span className="cont">홍학생103(고3ㆍ본사) </span>
              </div>
              <div className="info">
                <span className="tit">전화번호</span>
                <span className="cont">010-1234-134</span>
              </div>
              <div className="info">
                <span className="tit">부모폰</span>
                <span className="cont">부) 010-1234-0134 | 모) 010-1345-3214</span>
              </div>
              <div className="info">
                <span className="tit">홍보</span>
                <span className="cont">김홍보320</span>
              </div>
              <div className="info">
                <span className="tit">담임</span>
                <span className="cont">김담임445</span>
              </div>
              <hr className="com_divider" />
              <div className="info">
                <span className="tit">수업 방법</span>
                <span className="cont">대면</span>
              </div>
              <div className="info">
                <span className="tit">수업 과목</span>
                <span className="cont">과탐</span>
              </div>
              <div className="info">
                <span className="tit">수업 상세</span>
                <span className="cont">사회문화, 경제, 밥과정서</span>
              </div>
              <div className="info">
                <span className="tit">기수 / 타임</span>
                <span className="cont">2기 / 2T</span>
              </div>
              <hr className="com_divider" />
              <div className="info">
                <span className="tit">회차 / 타임 </span>
                <span className="cont">45회 / 2T</span>
              </div>
              <div className="info">
                <span className="tit">1회 수업료 </span>
                <span className="cont">25,000</span>
              </div>
              <div className="info">
                <span className="tit">수업료</span>
                <span className="cont">4,500,000</span>
              </div>
              <div className="info">
                <span className="tit">DC코드ㅣ할인금액</span>
                <span className="cont">형제할인 5%ㅣ45,000</span>
              </div>
              <div className="info">
                <span className="tit">실 수업료</span>
                <span className="cont com_blue_txt">2,495,000</span>
              </div>
              <hr className="com_divider" />
              <div className="info">
                <span className="tit">완성 여부</span>
                <span className="cont">Y</span>
              </div>
              <div className="info">
                <span className="tit">비교 수업</span>
                <span className="cont">N</span>
              </div>
              <div className="info">
                <span className="tit">첫 수업일</span>
                <span className="cont">2022, 08, 25 | 19:30</span>
              </div>
              <div className="info">
                <span className="tit">마지막 수업일</span>
                <span className="cont">2023, 05, 30 | 20:30</span>
              </div>
              <div className="info">
                <span className="tit">수업 장소</span>
                <span className="cont">경기도 수원시 팔달구 팔달로1465 모여라 빌딩 203호</span>
                <button className="com_btn gray">출석부 보기</button>
              </div>
              <div className="info">
                <span className="tit">진행 수업 수</span>
                <span className="cont">45 / 65</span>
              </div>
              <div className="info">
                <span className="tit">진행률</span>
                <span className="cont">65%</span>
              </div>
            </div>
          </div>
          {selectValue === 'rdo03' ? (
            <>
              <div className="com_board_box">
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>보류 시작일</th>
                      <td>
                        <div className="date_wrap">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>재개 예상일</th>
                      <td>
                        <div className="date_wrap">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <>
              <div className="com_board_box">
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>변경될 타임</th>
                      <td>
                        <input type="text" className="input ws" defaultValue={`3T`} />
                      </td>
                    </tr>
                    <tr>
                      <th>변경 일 </th>
                      <td>
                        <div className="date_wrap">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className="com_board_box">
            <textarea name="" id="" className="textarea" placeholder="사유 입력"></textarea>
          </div>
        </div>
        <div className="btn_container">{selectValue === 'rdo03' ? <button className="com_btn orange s">등록</button> : <button className="com_btn orange s">저장</button>}</div>
      </Modal>
    </>
  );
}

export default PopTimeChangeReport;
